import { createIcon } from "app/icons/createIcon";
import _AirplaneFilledIcon from "./AirplaneFilledIcon";
import _AirplaneStrokeIcon from "./AirplaneStrokeIcon";
import _AirplaneTakeOffFilledIcon from "./AirplaneTakeOffFilledIcon";
import _AirplaneTakeOffStrokeIcon from "./AirplaneTakeOffStrokeIcon";
import _BaggageLDisabledFilledIcon from "./BaggageLDisabledFilledIcon";
import _BaggageLDisabledStrokeIcon from "./BaggageLDisabledStrokeIcon";
import _BaggageLFilledIcon from "./BaggageLFilledIcon";
import _BaggageLStrokeIcon from "./BaggageLStrokeIcon";
import _BaggageMDisabledFilledIcon from "./BaggageMDisabledFilledIcon";
import _BaggageMDisabledStrokeIcon from "./BaggageMDisabledStrokeIcon";
import _BaggageMFilledIcon from "./BaggageMFilledIcon";
import _BaggageMStrokeIcon from "./BaggageMStrokeIcon";
import _BaggageSDisabledFilledIcon from "./BaggageSDisabledFilledIcon";
import _BaggageSDisabledStrokeIcon from "./BaggageSDisabledStrokeIcon";
import _BaggageSFilledIcon from "./BaggageSFilledIcon";
import _BaggageSStrokeIcon from "./BaggageSStrokeIcon";
import _BeachFilledIcon from "./BeachFilledIcon";
import _BeachStrokeIcon from "./BeachStrokeIcon";
import _BedFilledIcon from "./BedFilledIcon";
import _BedStrokeIcon from "./BedStrokeIcon";
import _FlashIcon from "./FlashIcon";
import _FlightBedBoldIcon from "./FlightBedBoldIcon";
import _FlightHotelBoldIcon from "./FlightHotelBoldIcon";
import _FlightHotelFilledIcon from "./FlightHotelFilledIcon";
import _FlightHotelStrokeIcon from "./FlightHotelStrokeIcon";
import _FlightInboundFilledIcon from "./FlightInboundFilledIcon";
import _FlightInboundStrokeIcon from "./FlightInboundStrokeIcon";
import _FlightOutboundFilledIcon from "./FlightOutboundFilledIcon";
import _FlightOutboundStrokeIcon from "./FlightOutboundStrokeIcon";
import _Hotel2Icon from "./Hotel2Icon";
import _HotelFilledIcon from "./HotelFilledIcon";
import _HotelStrokeIcon from "./HotelStrokeIcon";
import _MapFilledIcon from "./MapFilledIcon";
import _MapSolidIcon from "./MapSolidIcon";
import _MapStrokeIcon from "./MapStrokeIcon";
import _MealFilledIcon from "./MealFilledIcon";
import _MealStrokeIcon from "./MealStrokeIcon";
import _PalmFilledIcon from "./PalmFilledIcon";
import _PalmStrokeIcon from "./PalmStrokeIcon";
import _PinFilledIcon from "./PinFilledIcon";
import _PinStrokeIcon from "./PinStrokeIcon";
import _SeatFilledIcon from "./SeatFilledIcon";
import _SeatStrokeIcon from "./SeatStrokeIcon";
import _StopoverFilledIcon from "./StopoverFilledIcon";
import _StopoverStrokeIcon from "./StopoverStrokeIcon";
import _TourFilledIcon from "./TourFilledIcon";
import _TourStrokeIcon from "./TourStrokeIcon";
import _ZoneFilledIcon from "./ZoneFilledIcon";
import _ZoneStrokeIcon from "./ZoneStrokeIcon";

export const AirplaneFilledIcon = createIcon(_AirplaneFilledIcon);
export const AirplaneStrokeIcon = createIcon(_AirplaneStrokeIcon);
export const AirplaneTakeOffFilledIcon = createIcon(_AirplaneTakeOffFilledIcon);
export const AirplaneTakeOffStrokeIcon = createIcon(_AirplaneTakeOffStrokeIcon);
export const BaggageLDisabledFilledIcon = createIcon(_BaggageLDisabledFilledIcon);
export const BaggageLDisabledStrokeIcon = createIcon(_BaggageLDisabledStrokeIcon);
export const BaggageLFilledIcon = createIcon(_BaggageLFilledIcon);
export const BaggageLStrokeIcon = createIcon(_BaggageLStrokeIcon);
export const BaggageMDisabledFilledIcon = createIcon(_BaggageMDisabledFilledIcon);
export const BaggageMDisabledStrokeIcon = createIcon(_BaggageMDisabledStrokeIcon);
export const BaggageMFilledIcon = createIcon(_BaggageMFilledIcon);
export const BaggageMStrokeIcon = createIcon(_BaggageMStrokeIcon);
export const BaggageSDisabledFilledIcon = createIcon(_BaggageSDisabledFilledIcon);
export const BaggageSDisabledStrokeIcon = createIcon(_BaggageSDisabledStrokeIcon);
export const BaggageSFilledIcon = createIcon(_BaggageSFilledIcon);
export const BaggageSStrokeIcon = createIcon(_BaggageSStrokeIcon);
export const BeachFilledIcon = createIcon(_BeachFilledIcon);
export const BeachStrokeIcon = createIcon(_BeachStrokeIcon);
export const BedFilledIcon = createIcon(_BedFilledIcon);
export const BedStrokeIcon = createIcon(_BedStrokeIcon);
export const FlashIcon = createIcon(_FlashIcon);
export const FlightBedBoldIcon = createIcon(_FlightBedBoldIcon);
export const FlightHotelBoldIcon = createIcon(_FlightHotelBoldIcon);
export const FlightHotelFilledIcon = createIcon(_FlightHotelFilledIcon);
export const FlightHotelStrokeIcon = createIcon(_FlightHotelStrokeIcon);
export const FlightInboundFilledIcon = createIcon(_FlightInboundFilledIcon);
export const FlightInboundStrokeIcon = createIcon(_FlightInboundStrokeIcon);
export const FlightOutboundFilledIcon = createIcon(_FlightOutboundFilledIcon);
export const FlightOutboundStrokeIcon = createIcon(_FlightOutboundStrokeIcon);
export const Hotel2Icon = createIcon(_Hotel2Icon);
export const HotelFilledIcon = createIcon(_HotelFilledIcon);
export const HotelStrokeIcon = createIcon(_HotelStrokeIcon);
export const MapFilledIcon = createIcon(_MapFilledIcon);
export const MapSolidIcon = createIcon(_MapSolidIcon);
export const MapStrokeIcon = createIcon(_MapStrokeIcon);
export const MealFilledIcon = createIcon(_MealFilledIcon);
export const MealStrokeIcon = createIcon(_MealStrokeIcon);
export const PalmFilledIcon = createIcon(_PalmFilledIcon);
export const PalmStrokeIcon = createIcon(_PalmStrokeIcon);
export const PinFilledIcon = createIcon(_PinFilledIcon);
export const PinStrokeIcon = createIcon(_PinStrokeIcon);
export const SeatFilledIcon = createIcon(_SeatFilledIcon);
export const SeatStrokeIcon = createIcon(_SeatStrokeIcon);
export const StopoverFilledIcon = createIcon(_StopoverFilledIcon);
export const StopoverStrokeIcon = createIcon(_StopoverStrokeIcon);
export const TourFilledIcon = createIcon(_TourFilledIcon);
export const TourStrokeIcon = createIcon(_TourStrokeIcon);
export const ZoneFilledIcon = createIcon(_ZoneFilledIcon);
export const ZoneStrokeIcon = createIcon(_ZoneStrokeIcon);
